
const SET_CUSTOMERS= (state, customers) => {
  state.customers = customers;
  state.outDated=false;
};

const UPDATE_CUSTOMERS = (state, customers)=>{
  state.customers.push(...customers);
}

const SET_SEARCH_TERMS = (state, searchTerms) =>{
  state.search = searchTerms;
}

const SET_LOADING = (state, loadingState)=>{
  state.loading = loadingState;
}


const INVALIDATE_LIST = (state) =>{
  state.outDated = true;
}

const SET_COUNT = (state, count) =>{
  state.count = count;
}

const SET_PAGES = (state, pages) =>{
  state.pages = pages;
}

const SET_PAGE = (state, page) =>{
  state.page = page;
}

const SET_MODE = (state, mode)=>{
  state.mode = mode;
}

const SET_SEARCH = (state, search)=>{
  state.search = search;
}

const SET_CHECKED_CUSTOMER_TYPES = (state, checkedCustomerTypes)=>{
  state.filters.checkedCustomerTypes = checkedCustomerTypes;
}

const SET_CHECKED_CUSTOMER_CLASSES = (state, checkedCustomerClasses)=>{
  state.filters.checkedCustomerClasses=checkedCustomerClasses;
}

const SET_CHECKED_CUSTOMER_TAGS = (state, checkedCustomerTags) =>{
  state.filters.checkedTags = checkedCustomerTags;
}

const RESET_FILTERS = (state)=>{
  state.filters.active =true;
  state.filters.checkedCustomerTypes =[];
  state.filters.checkedCustomerClasses= [];
  state.filters.checkedTags = [];
  state.filters.checkedReps = [];
  state.filters.checkedTerritories = [];
  state.filters.withoutReps=false;
  state.filters.withoutTerritories=false;
}

const SET_ACTIVE_CUSTOMER_FILTER = (state, active) =>{
  state.filters.active = active;
}

const SET_CHECKED_REPS = (state, checkedReps) => {
  state.filters.checkedReps = checkedReps;
}

const SET_CHECKED_TERRITORIES = (state, checkedTerritories) =>{
  state.filters.checkedTerritories = checkedTerritories;
}

const SET_WITHOUT_REPS_FILTER = (state, withoutReps) =>{
  state.filters.withoutReps = withoutReps;
}

const SET_WITHOUT_TERRITORIES_FILTER = (state, withoutTerritories) =>{
  state.filters.withoutTerritories = withoutTerritories;
}

const SET_ORDER_BY = (state, orderBy)=>{
  state.orderBy = orderBy;
}

const SET_SORT_ICON = (state, sortIcon)=>{
  state.sort_icon = sortIcon;
}

const SET_CHECKED_PORTAUS_COMPANIES = (state, checkedPortausCompanies) => {
  state.filters.checkedPortausCompanies = checkedPortausCompanies;
}

export default {
  SET_MODE,
  SET_CUSTOMERS,
  UPDATE_CUSTOMERS,
  SET_SEARCH_TERMS,
  SET_LOADING,
  INVALIDATE_LIST,
  SET_COUNT,
  SET_PAGES,
  SET_PAGE,
  SET_MODE,
  SET_SEARCH,
  SET_CHECKED_CUSTOMER_CLASSES,
  SET_CHECKED_CUSTOMER_TYPES,
  RESET_FILTERS,
  SET_ACTIVE_CUSTOMER_FILTER,
  SET_CHECKED_CUSTOMER_TAGS,
  SET_CHECKED_REPS,
  SET_CHECKED_TERRITORIES,
  SET_WITHOUT_REPS_FILTER,
  SET_WITHOUT_TERRITORIES_FILTER,
  SET_ORDER_BY,
  SET_SORT_ICON,
  SET_CHECKED_PORTAUS_COMPANIES,
};
